module.exports = __webpack_public_path__ + "img/19.9a5ae32b.jpg";